<div fxLayout="column" class="container">
   <div fxFlex="1 1 auto" class="call-list">
      <ng-template #tooltipTemplate let-anchor>
         <span>{{ anchor.nativeElement.innerText }}</span>
      </ng-template>
      <kendo-grid
         samwebPersistKendoGrid
         samwebVirtualScrollKendoGrid
         kendoTooltip
         #grid
         style="height: 100%"
         [virtualScrollData]="callList$ | async"
         [virtualScrollBufferTime]="'0'"
         [columnMenu]="true"
         [sortable]="false"
         [resizable]="true"
         [reorderable]="true"
         (cellClick)="onCellClick($event)"
         (dblclick)="onRowDoubleClick()"
         showOn="none"
         [tooltipTemplate]="tooltipTemplate"
         #cellTooltipDirective="kendoTooltip"
         filter=".k-grid td"
         (mouseover)="showTooltip($event)"
         (mouseout)="hideTooltip()"
      >
         <kendo-grid-column
            field="currentUiPosition"
            [title]="'brick.brick_definitions.call_wait_list.columns.pos.title' | translate"
            [includeInChooser]="false"
         >
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
               <ng-container>
                  <span title="{{ 'brick.brick_definitions.call_wait_list.columns.pos.title' | translate }}">
                     {{ 'brick.brick_definitions.call_wait_list.columns.pos.title_short' | translate }}
                  </span>
               </ng-container>
            </ng-template>
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
               {{ rowIndex + 1 }}
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="type"
            [title]="'brick.brick_definitions.call_wait_list.columns.type.title' | translate"
         >
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
               <ng-container>
                  <span title="{{ 'brick.brick_definitions.call_wait_list.columns.type.title' | translate }}">
                     {{ 'brick.brick_definitions.call_wait_list.columns.type.title_short' | translate }}
                  </span>
               </ng-container>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               <span
                  class="cell-wrapper"
                  [class.parked-cell]="parkColor(dataItem)"
                  [style.border-color]="parkColor(dataItem) | safeStyle"
               >
                  <samweb-conversation-type
                     [conversationTypeAsSamwinValue]="dataItem.type"
                     [conversationIci]="dataItem.ici.ici"
                  ></samweb-conversation-type>
               </span>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="skillValue"
            [title]="'brick.brick_definitions.call_wait_list.columns.stars.title' | translate"
         >
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
               <ng-container>
                  <span title="{{ 'brick.brick_definitions.call_wait_list.columns.stars.title' | translate }}">
                     {{ 'brick.brick_definitions.call_wait_list.columns.stars.title_short' | translate }}
                  </span>
               </ng-container>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               <fa-icon
                  *ngIf="dataItem.skillInfoOpExt?.userSkillValue < dataItem.skillValue"
                  [icon]="skillStarsIcon"
               ></fa-icon>
               <fa-icon
                  *ngIf="dataItem.skillInfoOpExt?.userSkillValue >= dataItem.skillValue"
                  [icon]="skillStarsIconSolid"
               ></fa-icon>
               <ng-container *ngIf="dataItem.skillInfoOpExt?.userSkillValue">
                  {{ dataItem.skillInfoOpExt?.userSkillValue }} /
               </ng-container>
               {{ dataItem.skillValue }}
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="callerId"
            [title]="'brick.brick_definitions.call_wait_list.columns.callerId.title' | translate"
         >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               <samweb-peer-info [call]="dataItem"></samweb-peer-info>
            </ng-template>
         </kendo-grid-column>
         <kendo-grid-column
            field="ici"
            [title]="'brick.brick_definitions.call_wait_list.columns.ici.title' | translate"
         >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               {{ dataItem.ici | iciText }}
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="skillInfo.skillName"
            [title]="'brick.brick_definitions.call_wait_list.columns.skill.title' | translate"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-skill-short-info
                  [skillConfiguration]="dataItem.queueId | skillIdToShortSkillInfo$ | async"
               ></samweb-skill-short-info>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="memo"
            [title]="'brick.brick_definitions.call_wait_list.columns.memo.title' | translate"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-call-memo-cell [callId]="dataItem.callId" [memo]="memoValue(dataItem)"> </samweb-call-memo-cell>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="waitingSince"
            [title]="'brick.brick_definitions.call_wait_list.columns.wait.title' | translate"
         >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
               {{ dataItem.waitingSince | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="assignedUser"
            [title]="'brick.brick_definitions.call_wait_list.columns.assigned.title' | translate"
         >
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-user-short-info
                  *ngIf="dataItem.assignedUserId != 0"
                  [userId]="dataItem.assignedUserId"
               ></samweb-user-short-info>
            </ng-template>
         </kendo-grid-column>

         <ng-template kendoGridNoRecordsTemplate> </ng-template>
      </kendo-grid>
   </div>

   <samweb-skill-filter-bar
      [isFilteredBySkill]="isCallListFilteredBySkillFilter$ | async"
      [filteredSkill]="callListSkillFilter$ | async"
   >
   </samweb-skill-filter-bar>
</div>
